const ToastReducer=(state=null, action)=>{
    switch(action.type)
    {
        case "SET_SUCCESS":
            return action.alert;
        case "SET_DANGER":
            return action.alert;
        case "SET_WARNING":
            return action.alert;
        case "SET_INFORMATION":
            return action.alert;
        case "SET_ALERT_NULL":
            return action.alert;
        default :
            return state
    }
}
export default ToastReducer;